import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {Grid} from '@material-ui/core'
import './Card.css'
import './EventCard.css'
import photo from './hor (2).png'
import { Button, CardActionArea, CardActions } from '@mui/material';
import papy from './Papyrus.png'
import auto from './auto.png'
import mech from './mech.png'
import brug from './Brug.png'
import prad from './prad.png'
import acwork from './acwork.png'
import dtd from './dtd.png'
import HackM from './HackM.png'
import wcode from './wcode.png'
import webd from './webd.png'
import embed from './embed.png'
import cirtrix from './cirtrix.png'
import techquiz from './techquiz.png'
import treas from './treas.png'
import robot from './robot.png'
import elecq from './elecq.png'
import cine from './cine.png'
import photog from './photog.png'
import got from './got.png'
import ppt from './ppt.png'
import bp from './bp.png'
function EventCard() {
  return (
    <>
    <div className='main_card'>
    <div className='Card' style={{margin:'80px'}}>
      <Card sx={{ maxWidth: 600 ,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={photo}
          alt="fest photo"
        />
        <CardContent>
          

          <Typography  gutterBottom variant="h4" component="div" style={{textAlign:'center',}}>
          WE ARE BACK
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
          Welcome to largest yearly event of BCREC family.
           Take part in all amazing events and win prizes and show the world. Don't miss out a great opportunity learn and enrich your skill-set.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={treas}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            TREASURE HUNT
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    
    
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={cine}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            CINETRIX
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={photog}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            PHOTOGRAPHY
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={got}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            GAME OF THRONES
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={bp}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            B-PLAN
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={robot}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            ROBOTRIX
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={prad}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            PRADARSHAN
          </Typography>
          <Typography variant="body2" color="text.secondary">
          Execute an extraordinary project on trending topics and break the norms of being just ordinary.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={ppt}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            PPT PRESENTATION ( TECHNICAL IDEA )
          </Typography>
          <Typography variant="body2" color="text.secondary">
       
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={elecq}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            ELECTRONICS QUIZ
          </Typography>
          <Typography variant="body2" color="text.secondary">
          
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{maxWidth:600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={papy}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            PAPYRUS
          </Typography>
          <Typography variant="body2" color="text.secondary">
          Manifest your tech related ideas in form of documentation and presentation.
Maker or follower? Choice is yours!
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={cirtrix}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            CIRCUITRIX
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={techquiz}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            TECH QUIZ
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={auto}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            AUTOCAD
          </Typography>
          <Typography variant="body2" color="text.secondary">
          Show your designing and innovation skills using computer aided design software and GTake a step forward in Designing the Future.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={mech}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            MECH QUIZ
          </Typography>
          <Typography variant="body2" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={brug}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
            BRUG IT
          </Typography>
          <Typography variant="body2" color="text.secondary">
           
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={acwork}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          AutoCAD Workshop
          </Typography>
          <Typography variant="body2" color="text.secondary">
          It's time to have a break from all the stress you all are going through and it's time to learn something new and interesting which will be much fun.As you all know engineering design is the language of enginners , and we all want to design things fast and more accurately and yes we have it that is AutoCAD. Here in the workshop you will get to learn about the software and implementation of various tools.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={dtd}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          Dare To Debug
          </Typography>
          <Typography variant="body2" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={HackM}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          Hack Maze
          </Typography>
          <Typography variant="body2" color="text.secondary">
        
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={wcode}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          WannaCode
          </Typography>
          <Typography variant="body2" color="text.secondary">
      
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={webd}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          WEB D
          </Typography>
          <Typography variant="body2" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='Card' style={{margin:'80px'}}>
    <Card sx={{ maxWidth: 600,boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="335"
          image={embed}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h5" component="div">
          EMBED-IT
          </Typography>
          <Typography variant="body2" color="text.secondary">

          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    </div>
    </>
  )
}

export default EventCard